export enum TradeType {
  Other = 0,
  Plumbing,
  Electricity,
  Building,
  Ventilation,
}
